import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { CMMainComponent } from './components/cm-main/cm-main.component';
import { CMRoutingModule } from './cm-routing.module';
import { ContentWizardComponent } from './components/content-wizard/content-wizard.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MaterialModule } from 'src/app/material/material.module';
import { ContentViewComponent } from './components/content-view/content-view.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import EditorJS from '@editorjs/editorjs';
import { ImageCropperDialogComponent } from './components/image-cropper-dialog/image-cropper-dialog.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    declarations: [CMMainComponent, ContentWizardComponent, ContentViewComponent, ImageCropperDialogComponent],
    exports: [ContentViewComponent],
    imports: [
        MatIconModule,
        MatTableModule,
        MatButtonModule,
        FormsModule,
        CommonModule,
        CMRoutingModule,
        MatProgressSpinnerModule,
        TranslateModule,
        SharedModule,
        MaterialModule,
        MatFormFieldModule,
        MatTabsModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        MatInputModule,
        MatOptionModule,
        MatSelectModule,
        AngularEditorModule,
        ImageCropperModule,
        MatDialogModule,
    ],
    providers: [{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }],
})
export class CMModule {}
